import { addCursorLoader, api, removeCursorLoader, url } from 'dmui_components'

class OrgRepository {
	constructor() {
		this._abortController = undefined
	}
	async __abortAndResetAbortController() {
		if (this._abortController) {
			this._abortController.abort()
			this._abortController = undefined
		}
		this._abortController = new AbortController()
	}

	async fetchOrgsFromApi(filter) {
		try {
			this.__abortAndResetAbortController()
			addCursorLoader()
			const result = await api(url`/core_org?search=${filter}`, { abortController: this._abortController })
			return result
		} catch (e) {
			console.error('Error fetching orgs', e)
		} finally {
			removeCursorLoader()
		}
	}

	async fetchOrgById(org_id) {
		try {
			addCursorLoader()
			const result = await api(`/core_org/${org_id}`)
			return result
		} catch (e) {
			console.error('Error fetching org', e)
		} finally {
			removeCursorLoader()
		}
	}
}

export default new OrgRepository()
